import Breadcrumb from '../components/Breadcrumb';
import { useParams } from 'react-router-dom';
import { useFetch } from '../hook/useFecth';
import ViewProfileLayer from '../components/ViewProfileLayer';

function Edit({ id }) {
    const { data, mutate } = useFetch(`usuario/${id}`);
    return <ViewProfileLayer data={data} mutate={mutate} backTo="/usuarios" />;
}

function Layer() {
    const { id } = useParams();

    if (id) return <Edit id={id} />;

    return <ViewProfileLayer backTo="/usuarios" />;
}

const UsersPage = () => {
    const { id } = useParams();

    return (
        <>
            <Breadcrumb
                title={!Boolean(id) ? 'Cadastrar - Usuario' : 'Editar - Usuario'}
                icon={!Boolean(id) ? 'solar:user-plus-outline' : 'solar:user-check-outline'}
            />
            <Layer />
        </>
    );
};

export default UsersPage;
